<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['配对会主题']"/>
    <div class="rhBrand-content common-padding">
       <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input v-model.trim="title" placeholder="请输入标题" clearable size="small"></el-input>
          </el-col>
          <el-col :span="5">
            <el-button @click="search" class="btn-search" round icon="el-icon-search" size="small">查询
            </el-button>
            <el-button @click="reset" type="warning" round icon="el-icon-refresh" size="small">重置
            </el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" class="flex-1" stripe height="100%" style="width: 100%" border>
            <el-table-column type="index" width="80px" align="center" label="序号" fixed></el-table-column>
            <el-table-column prop="title" align="center" label="标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="startTime" align="center" label="开始时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="endTime" align="center" label="结束时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="repeatStatus" align="center" label="否可报名多场配对会" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.repeatStatus ? (scope.row.repeatStatus === '1' ? '是' : '否') : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="shelfStatus" align="center" label="是否上下架" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.shelfStatus ? (scope.row.shelfStatus === '1' ? '是' : '否') : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="introduce" align="center" label="简介" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <div class="btn-box">
                  <el-button
                      icon="el-icon-document"
                      type="text"
                      size="small"
                      @click="checkMateMeet(scope.row.id)"
                  >查看配对会列表
                  </el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes"
              :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  name: 'mateMeetTopic',
  data () {
    return {
      exportLoading: false,
      type: '',
      title: '',
      status: '',
      tableData: [],
      tableHeight: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  components: {
    navHeader
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 360
    this.getPageList()
  },
  methods: {
    async getPageList () {
      let {data: res} = await this.$http.post('/mateMeet/getPageList', {
        title: this.title,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      }
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    reset () {
      this.title = ''
      this.type = ''
      this.status = ''
      this.currentPage = 1
      this.getPageList()
    },
    add () {
      this.$router.push('/mateMeetTopicDetail')
    },
    checkMateMeet (meetId) {
      this.$router.push({
        name: 'MeetSession',
        query: {meetId}
      })
    },
    edit (id) {
      this.$router.push({
        name: 'MateMeetTopicDetail',
        params: {id, type: 'edit'}
      })
    },
    upOrDown (id, shelfStatus) {
      let tip = ''
      let status = ''
      if (!shelfStatus || shelfStatus === '2') {
        tip = '确定上架?'
        status = '1'
      } else {
        tip = '确定下架?'
        status = '2'
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http
          .post('/mateMeet/modifyShelfStatus', { id, shelfStatus: status })
          .then((res) => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.getPageList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(() => {
          })
      })
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    handleDelete (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/mateMeet/batchDelete', {ids: id}).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/mateMeetTopic/index.vue